import * as React from "react";
import { createContainer } from "./StateContainer";

const useLoadingProgressContainer = () => {
  const [show, setShow] = React.useState<boolean>(false);
  return {
    show,
    setShow,
  };
};
const LoadingProgressContainerState = createContainer(
  useLoadingProgressContainer
);

export const LoadingProgressContainer: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <LoadingProgressContainerState.Provider>
      {children}
    </LoadingProgressContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useLoadingProgress = LoadingProgressContainerState.useContainer;
